import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { add_new_category } from 'modules/api/market-api';

interface Props {
  selected: boolean;
}

const CustomDiv = styled.div<Props>`
  padding-top: 8px!important;
  border: ${props => { 
    if ( props.selected === true ) { 
      return '2px solid #1976d2' 
    } else {
      return 'none'
    } 
  }};
`;

export default function AddCategoryDialog(props:any) {
  const [ open, setOpen ] = React.useState<boolean>(false);
  const [ category, setCategory ] = React.useState<string>('');
  const [ isLoading, setIsLoading ] = React.useState<boolean>(false)

  React.useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  React.useEffect(() => {
    // setItemData(props.imgArr)
  }, [props.imgArr])

  const handleClose = () => {
    setCategory('')
    props.setOpen(false);
  };

  const handleSave = () => {
    try {
      (async () => {
        setIsLoading(true)

        let added_result = await add_new_category(props.family_name, category.trim())

        if ( added_result.status === 'success' ) {
          let added_category = added_result.addResult         

          // let copy_products = [...props.products]
          // copy_products.push(added_category)

          props.setProducts((prev: any[]) => {
            let next = [...prev]
            let prev_active_index = next.findIndex(ele => ele.active === true)

            if ( prev_active_index !== -1 ) {
                next[prev_active_index].active = false
            }

            added_category = Object.assign(added_category, {active: true})
            next.push(added_category)

            return next
          })

          setIsLoading(false)
          props.setOpen(false);
          setCategory("")
        } else if ( added_result.status === 'error' ) {
          setIsLoading(false)
          props.setOpen(false);
          setCategory("")
        }
      })()
    } catch ( e ) {
      // console.log(e)
    }
    
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCategory(e.target.value)
  }

  return (
    isLoading === true ? 
        <> 
          <div>
            <Dialog open={open} onClose={handleClose} fullWidth >
              <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={isLoading}
                  // onClick={handleClose}
              >
                  <CircularProgress color="inherit"/>
                  <p>&nbsp;&nbsp; Saving Data ...</p>
              </Backdrop>
              <DialogTitle>Add New Category</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Cagetory Name:
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  value={category}
                  onChange={handleCategoryChange}
                  // onKeyDown={handleKeyDown}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSave}>Save</Button>
                <Button onClick={handleClose}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </div>
        </> :
        <>
          <div>
            <Dialog open={open} onClose={handleClose} fullWidth >
              <DialogTitle>Add New Category</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Category Name:
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  fullWidth
                  value={category}
                  onChange={handleCategoryChange}
                  // onKeyDown={handleKeyDown}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleSave}>Save</Button>
                <Button onClick={handleClose}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </div>
        </>
    
  );
}
